import React, { FC } from 'react';
import { ReactComponent as ConnectWalletIcon } from '@blink/assets/src/icons/connectWallet.svg';

export const ConnectWalletBanner: FC = () => {
    return (
        <div className='flex justify-center items-center flex-col p-8 px-10 bg-primary border border-opaque'>
            <ConnectWalletIcon />
            <div className='text-primary text-lg font-semibold mt-3 tracking-[-0.019em]'>
                Please, connect your wallet
            </div>
            <div className='text-center text-secondary mt-3 tracking-[-0.019em] font-normal max-w-[560px]'>
                Please connect your wallet to see your supplies, borrowings, and open positions
            </div>
        </div>
    );
};
